<template>
  <div class="columns is-multiline">
    <div
      v-for="box in boxes"
      :key="box.title"
      :class="['column', box.wide ? 'is-12' : 'is-6']"
    >
      <div class="box">
        <p class="heading">{{ box.title }}</p>
        <table class="table is-narrow is-fullwidth">
          <tbody>
            <tr v-for="line in box.lines" :key="line.label">
              <th class="has-text-grey has-text-weight-normal">
                {{ line.label }}
              </th>
              <td>{{ line.value || "—" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ORIGIN_LABELS,
  formatAddress,
  formatAgriculturalRegister,
  formatDate,
  formatDeceased,
  formatLocality,
} from "@/helpers/resdps";

export default {
  name: "SuccessionFileSummary",
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    boxes() {
      const d = this.detail;
      return [
        {
          title: "Sesizare",
          lines: [
            { label: "Tip", value: ORIGIN_LABELS[d.origin] || d.origin },
            {
              label: "Data primirii cererii",
              value: formatDate(d.cdpsReceivedDate),
            },
          ],
        },
        {
          title: "Defunct",
          lines: [
            { label: "Nume", value: formatDeceased(d) },
            { label: "CNP", value: d.cnp },
            { label: "Motivul lipsei CNP", value: d.cnpMissingReason },
          ],
        },
        {
          title: "Ultimul domiciliu",
          lines: [
            {
              label: "Localitate",
              value: formatLocality(d.domicileLocality, d.domicileCounty),
            },
            { label: "Adresa", value: formatAddress(d) },
            { label: "Cod unic de adresa", value: d.domicileCua },
          ],
        },
        {
          title: "Deces",
          lines: [
            { label: "Data decesului", value: formatDate(d.dateOfDeath) },
            {
              label: "Numarul actului de deces",
              value: d.deathCertificateNumber,
            },
            {
              label: "Locul decesului",
              value: formatLocality(d.deathPlaceLocality, d.deathPlaceCounty),
            },
          ],
        },
        {
          title: "Evidente locale",
          lines: [
            { label: "Nr. de rol nominal unic", value: d.fiscalRollNumber },
            {
              label: "Registrul agricol",
              value: formatAgriculturalRegister(d),
            },
          ],
        },
        {
          title: "Observatii",
          wide: true,
          lines: [{ label: "Observatii", value: d.observations }],
        },
      ];
    },
  },
};
</script>
